/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/prop-types */
import { useCallback } from 'react';
import styled from 'styled-components';

const Bar = styled.div`
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  background-color: #f8f9fa;
  border-top: 1px solid #e1e4e8;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
  z-index: 10;
  padding: 6px 8px;
`;

const ButtonBase = styled.div`
  width: 52px;
  border: none;
  font-size: 0.62rem;
  padding: 5px 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 3px;

  :hover {
    background-color: rgb(84, 190, 242);
    cursor: pointer;
    border-radius: 12px;
  }

  * {
    pointer-events: none;
  }
`;

const ChatButton = styled(ButtonBase)``;
const ArButton = styled(ButtonBase)``;

const ScreenButton = styled(ButtonBase)`
  width: auto;
  padding: 5px 6px;

  .sharing {
    color: #ee2560;
  }
`;

const FaIcon = styled.i`
  width: 18px;
  font-size: 15px;
  display: flex;
  justify-content: center;
`;

const StopButton = styled.div`
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #ee2560;
  color: white;
  border-radius: 50%;
  cursor: pointer;
  flex-shrink: 0;

  :hover {
    background-color: #f25483;
  }

  i {
    font-size: 16px;
    pointer-events: none;
  }
`;

const CameraButton = styled(ButtonBase)`
  position: relative;
  margin: 0 2px;

  .fa-microphone-slash {
    color: #ee2560;
  }

  .fa-video-slash {
    color: #ee2560;
  }
`;

const CameraWrapper = styled.div`
  position: relative;
  display: flex;
`;

const SwitchMenu = styled.div`
  display: flex;
  position: absolute;
  width: 20px;
  top: 7px;
  left: 58px;
  z-index: 1;

  :hover {
    background-color: rgb(84, 190, 242);
    cursor: pointer;
    border-radius: 15px;
  }

  * {
    pointer-events: none;
  }

  > i {
    width: 90%;
    font-size: calc(10px + 1vmin);
  }
`;

const SwitchList = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  bottom: 60px;
  left: 0;
  background-color: #4ea1d3;
  color: white;
  padding: 5px 10px;
  text-align: left;
  z-index: 20;

  > div {
    font-size: 0.85rem;
    padding: 1px;
    margin-bottom: 5px;

    :not(:last-child):hover {
      background-color: rgb(84, 190, 242);
      cursor: pointer;
    }
  }

  > div:last-child {
    border-top: 1px solid white;
    cursor: context-menu !important;
  }
`;

const BottomBar = ({
  clickAr,
  clickChat,
  clickCameraDevice,
  goToBack,
  toggleCameraAudio,
  userVideoAudio,
  clickScreenSharing,
  screenShare,
  videoDevices,
  showVideoDevices,
  setShowVideoDevices,
  isPhysio,
}) => {
  const handleToggle = useCallback(() => {
    setShowVideoDevices((state) => !state);
  }, [setShowVideoDevices]);

  return (
    <Bar>
      <CameraWrapper>
        <CameraButton onClick={toggleCameraAudio} data-switch="video">
          <div>
            {userVideoAudio.video ? (
              <FaIcon className="fas fa-video" />
            ) : (
              <FaIcon className="fas fa-video-slash" />
            )}
          </div>
          Kamera
        </CameraButton>
        {showVideoDevices && (
          <SwitchList>
            {videoDevices.length > 0 &&
              videoDevices.map((device) => {
                return (
                  <div
                    key={device.deviceId}
                    onClick={clickCameraDevice}
                    data-value={device.deviceId}
                  >
                    {device.label}
                  </div>
                );
              })}
            <div>Zmień kamerę</div>
          </SwitchList>
        )}
        <SwitchMenu onClick={handleToggle}>
          <i className="fas fa-angle-up" />
        </SwitchMenu>
      </CameraWrapper>
      <CameraButton onClick={toggleCameraAudio} data-switch="audio">
        <div>
          {userVideoAudio.audio ? (
            <FaIcon
              className="fas fa-microphone"
              style={{ display: 'flex', justifyContent: 'center' }}
            />
          ) : (
            <FaIcon className="fas fa-microphone-slash" />
          )}
        </div>
        Dźwięk
      </CameraButton>
      <ChatButton onClick={clickChat}>
        <div>
          <FaIcon className="fas fa-comments" />
        </div>
        Czat
      </ChatButton>
      <ScreenButton onClick={clickScreenSharing}>
        <div>
          <FaIcon
            className={`fas fa-desktop ${screenShare ? 'sharing' : ''}`}
          />
        </div>
        Ekran
      </ScreenButton>
      {isPhysio && clickAr && (
        <ArButton onClick={clickAr}>
          <div>
            <FaIcon className="fas fa-vector-square" />
          </div>
          AR
        </ArButton>
      )}
      <StopButton onClick={goToBack}>
        <i className="fas fa-phone-slash" />
      </StopButton>
    </Bar>
  );
};

export default BottomBar;
